<template>
  <div>
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style="width: 105px; height: 105px"
    >
      <circle
        class="line-loading3-a stroke1 fill1"
        cx="51.2326"
        cy="24.8605"
        r="6.32558"
        fill="rgba(255,255,255,1)"
        stroke="rgba(178,42,240,1)"
        stroke-width="2px"
        style="animation-duration: 0.7s"
      ></circle>
      <circle
        class="line-loading3-b stroke1 fill1"
        cx="68.8139"
        cy="33.6512"
        r="6.32558"
        fill="rgba(255,255,255,1)"
        stroke="rgba(178,42,240,1)"
        stroke-width="2px"
        style="animation-duration: 0.7s"
      ></circle>
      <circle
        class="line-loading3-c stroke1 fill1"
        cx="74.6745"
        cy="51.2326"
        r="6.32558"
        fill="rgba(255,255,255,1)"
        stroke="rgba(178,42,240,1)"
        stroke-width="2px"
        style="animation-duration: 0.7s"
      ></circle>
      <circle
        class="line-loading3-d stroke1 fill1"
        cx="67.3488"
        cy="68.814"
        r="6.32558"
        fill="rgba(255,255,255,1)"
        stroke="rgba(178,42,240,1)"
        stroke-width="2px"
        style="animation-duration: 0.7s"
      ></circle>
      <circle
        class="line-loading3-e stroke1 fill1"
        cx="51.2326"
        cy="76.1395"
        r="6.32558"
        fill="rgba(255,255,255,1)"
        stroke="rgba(178,42,240,1)"
        stroke-width="2px"
        style="animation-duration: 0.7s"
      ></circle>
      <circle
        class="line-loading3-f stroke1 fill1"
        cx="33.6513"
        cy="68.814"
        r="6.32558"
        fill="rgba(255,255,255,1)"
        stroke="rgba(178,42,240,1)"
        stroke-width="2px"
        style="animation-duration: 0.7s"
      ></circle>
      <circle
        class="line-loading3-g stroke1 fill1"
        cx="26.3256"
        cy="51.2326"
        r="6.32558"
        fill="rgba(255,255,255,1)"
        stroke="rgba(178,42,240,1)"
        stroke-width="2px"
        style="animation-duration: 0.7s"
      ></circle>
      <circle
        class="line-loading3-h stroke1 fill1"
        cx="33.6513"
        cy="32.186"
        r="6.32558"
        fill="rgba(255,255,255,1)"
        stroke="rgba(178,42,240,1)"
        stroke-width="2px"
        style="animation-duration: 0.7s"
      ></circle>
    </svg>
    <p class="accent--text text-h6 font-weight-bold">Please Wait...</p>
  </div>
</template>

<script>
export default {
  name: 'StrappLoader',

  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

  <style lang="css" scoped>
.line-loading3-a {
  animation: line-loading3-pulse 700ms infinite linear;
  transform-origin: 51.2px 24.8px;
}
.line-loading3-b {
  animation: line-loading3-pulse 700ms 100ms infinite linear;
  transform-origin: 68.8px 33.6px;
}
.line-loading3-c {
  animation: line-loading3-pulse 700ms 200ms infinite linear;
  transform-origin: 74.6px 51.2px;
}
.line-loading3-d {
  animation: line-loading3-pulse 700ms 300ms infinite linear;
  transform-origin: 67.3px 68.8px;
}
.line-loading3-e {
  animation: line-loading3-pulse 700ms 400ms infinite linear;
  transform-origin: 51.2px 76.1px;
}
.line-loading3-f {
  animation: line-loading3-pulse 700ms 500ms infinite linear;
  transform-origin: 33.6px 68.8px;
}
.line-loading3-g {
  animation: line-loading3-pulse 700ms 600ms infinite linear;
  transform-origin: 26.3px 51.2px;
}
.line-loading3-h {
  animation: line-loading3-pulse 700ms 700ms infinite linear;
  transform-origin: 33.6px 32.1px;
}
@keyframes line-loading3-pulse {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.8);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .line-loading3-a,
  .line-loading3-b,
  .line-loading3-c,
  .line-loading3-d,
  .line-loading3-e,
  .line-loading3-f,
  .line-loading3-g,
  .line-loading3-h {
    animation: none;
  }
}
</style>
